var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50.528 48.79C57.782 46.584 62.606 42.527 65 36.62c.986-2.35 1.479-5.196 1.479-8.542H50V0h30v22.527c0 10.178-2.447 18.487-7.342 24.929-4.894 6.44-12.27 10.622-22.13 12.544V48.79zm-50.002 0c7.088-2.278 11.86-6.192 14.316-11.744 1.333-2.918 1.895-5.907 1.684-8.968H0V0h30v22.527c0 10.462-2.509 18.86-7.526 25.195C17.456 54.057 10.14 58.15.526 60V48.79z","fill":"#F4F5F6"}));
}

Quote.defaultProps = {"width":"80","height":"60"};

module.exports = Quote;

Quote.default = Quote;
